import { database } from "../config";
import { ref, onValue, off } from "firebase/database";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import paths from "../Router/paths";

export const fetchJobListings = createAsyncThunk(
  "jobs/fetchJobListings",
  async (_, { dispatch }) => {
    const userRef = ref(database, `careers/`);
    dispatch(setLoading(true))
    return new Promise((resolve, reject) => {
      const unsubscribe = onValue(
        userRef,
        (snapshot) => {
          const data = snapshot.val();
          if (data) {
            const jobListings = Object.entries(data)
              .map(([categoryKey, jobs]) => ({
                category: categoryKey,
                jobs: Object.entries(jobs)
                  .map(([id, job]) => ({
                    ...job,
                    id,
                    link: paths.careersPage.path + `/listing/${job.req}`,
                  }))
                  .filter((job) => job.active !== false)
                  .sort((a, b) => Number(b.id) - Number(a.id)),
              }))
              .filter((category) => category.jobs.length > 0)

            dispatch(setJobListings(jobListings))
            dispatch(setLoading(false))
          } else {
            dispatch(setJobListings([]))
            dispatch(setLoading(false))
          }
          resolve(data);
        },
        (error) => {
          dispatch(setError(error));
          dispatch(setLoading(false))
          reject(error);
        }
      );
      return () => off(userRef, "value", unsubscribe);
    });
  }
)

const jobListingsSlice = createSlice({
  name: "jobs",
  initialState: {
    jobsData: null,
    loading: true,
    error: null,
  },
  reducers: {
    setJobListings: (state, action) => {
      state.jobsData = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobListings.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchJobListings.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(fetchJobListings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setJobListings, setLoading, setError } = jobListingsSlice.actions;
export default jobListingsSlice.reducer;
